<template lang="pug">
.conteudo.collapse-component(:id='id')
    .collapse-title-basic(
        v-if='isBasic',
        @click='changeColapse',
        :class='isExpanded ? "--expanded" : ""'
    )
        .title-colllapse-basic {{ title }}
        .title-line
        .icon-title-collapse-basic.mdi(:class='isExpanded ? "mdi-arrow-up-drop-circle-outline" : "mdi-arrow-down-drop-circle-outline"')
    .collapse-content-basic(
        v-if='isBasic',
        :class='isExpanded ? "--expanded" : ""'
    )
        slot.collapse-slot

    .collapse-title(
        v-if='!isBasic',
        @click='isExpanded = !isExpanded',
        :class='isExpanded ? "--expanded" : ""'
    )
        .mdi(color='var(--primary-white)' :class='isExpanded ? "mdi-chevron-up" : "mdi-chevron-down"')
        b {{ title }}
    .collapse-content(v-if='!isBasic', :class='isExpanded ? "--expanded" : ""')
        slot
</template>

<script>
export default {
    name: 'CollapseComponent',

    props: {
        id: {
            type: String,
            default: () => `collapse-${Math.ceil(Math.random() * 10000)}`,
        },

        title: {
            type: String,
            default: '',
        },

        isBasic: {
            type: Boolean,
            default: false,
        },

        isOpen: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            isExpanded: this.isOpen,
        };
    },
    methods: {
        changeColapse() {  
            this.isExpanded = !this.isExpanded;
            this.$children.forEach((item) => {     
                item.isExpanded = this.isExpanded; 
            });              
            
        },

    },
};
</script>

<style scoped>
.collapse-title {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: row;

    padding: 5px;
    background-color: var(--primary-green);
    color: var(--primary-white);
    cursor: pointer;

    border-radius: 5px;
}

.collapse-title-basic {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: row;

    padding: 5px;
    color: var(--primary-green);
    cursor: pointer;
}

.icon-title-collapse-basic {
    padding-left: 10px;
}

.collapse-title.--expanded {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
}

.title-colllapse-basic {
    text-align: left;
    padding-right: 10px;
    min-width: fit-content;
    max-width: 200px;
    font-weight: bolder;
}

.title-line {
    width: 100%;
    border-bottom: 2px solid var(--primary-dark-smoke);
    position: relative;
}

.collapse-content {
    width: calc(100% - 22px);
    visibility: hidden;
    height: 0px;
    padding: 10px;

    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
}

.collapse-content-basic {
    visibility: hidden;
    padding: 10px;
    height: 0px;
}

.collapse-content-basic.--expanded {
    visibility: visible;
    height: auto;
}

.collapse-content-basic::-webkit-scrollbar {
    width: 8px;
}

.collapse-content-basic::-webkit-scrollbar-track {
    background-color: var(--primary-smoke);
}

.collapse-content-basic::-webkit-scrollbar-thumb {
    border-radius: 100px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.collapse-content.--expanded {
    visibility: visible;
    background-color: var(--primary-white);
    padding: 10px;
    border: 1px solid var(--primary-dark-smoke);
    border-top: 0 solid;
    height: auto;
}

.collapse-content::-webkit-scrollbar {
    width: 8px;
}

.collapse-content::-webkit-scrollbar-track {
    background-color: var(--primary-smoke);
}

.collapse-content::-webkit-scrollbar-thumb {
    border-radius: 100px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
</style>
